export enum LogLevel {
  None = 0,
  Error = 1,
  Warn = 2,
  Verbose = 3,
  Debug = 4,
}
